import { render, staticRenderFns } from "./ProductTypesStats.vue?vue&type=template&id=f213fbc4&"
import script from "./ProductTypesStats.vue?vue&type=script&lang=js&"
export * from "./ProductTypesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports